import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CompanyAddress as SchemaCompanyAddress } from '../schemas/CompanyAddress';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Company
 */
export const GetCompanyAddressContentType = '' as const;
export type GetCompanyAddressRequest = void;
export type GetCompanyAddressResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful get company address
     */
    '200': {
        'application/json': SchemaCompanyAddress[];
    };
};
export type GetCompanyAddressResponseSuccess = GetCompanyAddressResponses['200']['application/json'];
export type GetCompanyAddressSearchParams = undefined;
export type GetCompanyAddressPathParameters = undefined;
export const GetCompanyAddressUrl = '/company/address' as const;
export const GetCompanyAddressMethod = 'GET' as const;
export const getGetCompanyAddressUrl = (_params?: GetCompanyAddressPathParameters) => GetCompanyAddressUrl;
